/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusUnteraufgabenListResponseDto } from '../../models/lexplus-unteraufgaben-list-response-dto';

export interface AufgabenControllerFindUnteraufgabenV1$Params {
  id: number;
  page?: number;
  limit?: number;
}

export function aufgabenControllerFindUnteraufgabenV1(http: HttpClient, rootUrl: string, params: AufgabenControllerFindUnteraufgabenV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusUnteraufgabenListResponseDto>> {
  const rb = new RequestBuilder(rootUrl, aufgabenControllerFindUnteraufgabenV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusUnteraufgabenListResponseDto>;
    })
  );
}

aufgabenControllerFindUnteraufgabenV1.PATH = '/v1/aufgaben/{id}/unteraufgaben';
